import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { SearchInputField } from "./Parts/index";
import IconSearch from "../../../src/svgs/icon_search.svg";
import styles from "@/styles/Form.module.scss";
import { useDeviceInfoQuery } from "@/hooks";

export default function ChannelSearchForm({ onSubmit, ...props }) {
  const { register, handleSubmit } = useForm();
  const { data } = useDeviceInfoQuery({ fetchPolicy: "cache-first" });
  const deviceInfo = data?.deviceInfo;
  const handleKeyDown = useCallback(
    (e) => {
      // Return
      if (e.key === "Enter" && deviceInfo?.isMobile) {
        setTimeout(() => {
          e.target.blur();
        }, 200);
      }
    },
    [deviceInfo]
  );

  return (
    <form
      action="#"
      onSubmit={handleSubmit(onSubmit)}
      className={styles.channelSearchForm}
      noValidate
    >
      <div>
        <IconSearch />
        <SearchInputField
          {...register("search")}
          placeholder="商品内検索"
          onKeyDown={handleKeyDown}
          {...props}
        />
      </div>
    </form>
  );
}
